export default __webpack_public_path__ + "static/media/3.1 System Error 01.29a9ea52.png";